<style>
	.identitySelect{
    position: relative;
    width:300px;
    height:auto;
    min-height: 1000px;
    background: #ffffff;
    box-shadow:0px 1px 6px rgba(153,152,155,0.16);
    border-radius:10px;
    padding:20px 0 20px 60px;
  }
  .identity{
      height:25px;
      width:auto;
      position: relative;
      margin-bottom: 35px;
      text-align: left;
      cursor: pointer;
  }
  .identity img{
    display: inline-block;
    top:2px;
    height:20px;
    width:20px;
    position: relative;
  }
  .identity span{
    margin-left:10px;
    line-height: 25px;
    font-size:18px;
    font-family:PingFang SC;
    color:rgba(77,77,77,1);
  }
</style>

<template>
  <div class='identitySelect'>
    <!-- 1为木工，2为门店，3为工厂，4为柜门厂，5为设备商，6为材料厂，7为软件服务，8为其他 -->
      <div class='identity' v-for='item in identityList' @click='changeIdentity' :data-identity='item.identity'>
        <img :src="now==item.identity?require('../assets/identity/'+item.identity+'_select.png'):require('../assets/identity/'+item.identity+'.png')">
        <span :style="now==item.identity?'color:rgba(81,71,231,1)':''">{{item.name}} ({{item.count}})</span>
      </div>
  </div>
</template>

<script>
	export default {
		components:{

		},
		props:[],
		data() {
			return {
        now:3,//当前选中
        identityList:[{
          identity:3,
          name:"柜柜工厂",
          count:"…"
        },{
          identity:2,
          name:"门店",
          count:"…"
        },{
          identity:1,
          name:"木工",
          count:"…"
        },{
          identity:5,
          name:"设备商",
          count:"…"
        },{
          identity:6,
          name:"材料厂",
          count:"…"
        },{
          identity:4,
          name:"柜门厂",
          count:"…"
        },{
          identity:7,
          name:"软件服务点",
          count:"…"
        },{
          identity:8,
          name:"其他",
          count:"…"
        }]
			}
		},
		computed: {

		},
		mounted() {
      let that=this
			that.$get('/guigui/exhibition/identityCount',{},res=>{
        let data=res.data
				 for(let key  in data){
                let list=that.identityList
				        for(let i=0,len=list.length;i<len;i++){
                  if(key==list[i].identity){
                    that.identityList[i].count=data[key]
                  }
                }
				  }
			})
		},
		methods: {
		  changeIdentity(e){
			let identity=parseInt(e.currentTarget.dataset.identity)
			if(this.now==identity){
			  return
			}
			// console.log(identity)
			this.now=identity
      this.$emit('changeIdentity',identity)
		  }
		}
	}
</script>
